{
  "close": "Sulje",
  "notifications": "{count, plural, one {# ilmoitus} other {# ilmoitusta}}."
}
